import { CategoryModel } from '@/http/models/ProductCategory/ProductCategory'

import React, { useEffect, useState } from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface CategorySelectFieldProps {
  field: FieldSchema
  value: any
  onChange: (value: any) => void
}

export const CategorySelectField = ({ field, value, onChange }: CategorySelectFieldProps) => {
  const [categories, setCategories] = useState<any[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true)
        // Assuming getList returns the expected structure or we need to check how it's wrapped
        // Based on comments in CategoryModel.ts: response.data = { page, length, count, result: [...] }
        const response = await CategoryModel.getList({
          query: { length: 100 }, // Fetch reasonable amount
        })

        // Inspecting CategoryModel.ts, it uses createHttpRequest which typically returns { data: ... }
        // The comment say "After unwrapping: response.data = ..."
        // Let's assume response.data.result is the array

        if (response.data && response.data.result) {
          setCategories(response.data.result)
        }
      } catch (error) {
        console.error('Failed to fetch categories', error)
      } finally {
        setLoading(false)
      }
    }

    fetchCategories()
  }, [])

  return (
    <Select value={value || ''} onValueChange={onChange}>
      <SelectTrigger className="h-12 font-medium">
        <SelectValue placeholder={loading ? 'Loading categories...' : 'Select Category'} />
      </SelectTrigger>
      <SelectContent>
        {categories.map((cat: any) => (
          <SelectItem key={cat._id} value={cat._id} className="font-medium">
            {cat.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
